export enum ExteriorGrade {
	bronze = 'bronze',
	gold = 'gold',
	silver = 'silver',
}

export const NumericGrade = {
	1: '1',
	2: '2',
	3: '3',
	4: '4',
	5: '5',
} as const;
